import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import '../../styles/ccsu-fm/main.css';

const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@ccsuyoutube';


const videos = [
    { title: 'CCSU Gyan Sabha Meerut 2026 Prof. Pankaj Mittal with Prof. Neelu Jain Gupta (audio)', date: 'Aired on 27/09/2026', src: 'http://cdn.ccsuniversity.ac.in/public/mp4/2026/09/ccsu%20fm%20radio/VID-20260928-WA0003.mp4' },
    { title: 'CCSU Gyan Sabha Meerut 2026 Prof. Sangeeta Shukla (Honorable Vice Chancellor)', date: 'Aired on 27/09/2026', src: 'https://youtu.be/FZmfkSL3TsA?si=CrQA7feQ6Wd8vvDm' },
    { title: 'CCSU Gyan Sabha Meerut 2026 MA SH Atul kothari with Prof. Neelu Jain Gupta', date: 'Aired on 27/09/2026', src: 'http://cdn.ccsuniversity.ac.in/public/mp4/2026/10/ccsu%20fm%20radio/MA%20SH%20Atul%20kothari.mp4'},
    { title: 'CCSU Gyan Sabha Meerut 2026 Prof. Tankeshware with Prof. Neelu Jain Gupta (audio)', date: 'Aired on 26/09/2026', src: 'http://cdn.ccsuniversity.ac.in/public/mp4/2026/10/ccsu%20fm%20radio/Prof.%20Tankeshware%20Kumar%205.51.mp4'},
    { title: 'CCSU Gyan Sabha Meerut 2026 Prof. N.C. Gautam with Prof. Neelu Jain Gupta (audio)', date: 'Aired on 26/09/2026', src: 'http://cdn.ccsuniversity.ac.in/public/mp4/2026/10/ccsu%20fm%20radio/Prof.%20Naresh%20chandra%20gautam%205.52.mp4'},
    { title: 'CCSU Gyan Sabha Meerut 2026 Prof. Sanjay Swami with Prof. Neelu Jain Gupta (audio)', date: 'Aired on 26/09/2026', src: 'http://cdn.ccsuniversity.ac.in/public/mp4/2026/10/ccsu%20fm%20radio/Prof.%20Sanjay%20Swami%209.40.mp4'},
    { title: 'CCSU Gyan Sabha Meerut 2026 Prof. Savita Sengar with Prof. Neelu Jain Gupta (audio)', date: 'Aired on 26/09/2026', src: 'http://cdn.ccsuniversity.ac.in/public/mp4/2026/10/ccsu%20fm%20radio/Prof.%20Savita%20Sengar%204.53.mp4'},
];

// Returns the YouTube video ID for any common YouTube link format, or null for other links.
const getYoutubeId = (url) => {
    const match = url.match(
        /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/
    );
    return match ? match[1] : null;
};

const Main = () => {
    const playerRef = useRef(null);
    const [current, setCurrent] = useState(null);   // index of the selected video
    const [error, setError] = useState('');

    const handleWatch = (index) => {
        setError('');
        setCurrent(index);
        // Bring the player into view, since the table may be scrolled below it
        setTimeout(() => {
            playerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
    };

    const handleClose = () => {
        setCurrent(null);
        setError('');
    };

    const renderPlayer = () => {
        const video = videos[current];
        const youtubeId = getYoutubeId(video.src);

        if (youtubeId) {
            return (
                <iframe
                    key={youtubeId}
                    src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            );
        }

        return (
            <video
                key={video.src}
                src={video.src}
                controls
                autoPlay
                playsInline
                preload="metadata"
                onError={() => setError('This video could not be loaded.')}
            >
                Your browser does not support the video element.
            </video>
        );
    };

    return (
        <div id='downloadMain'>
            <div className="download-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">CCSU@90.8 FM Radio & Podcasts</h2>

                                {/* Video player */}
                                {current !== null && (
                                    <div className="fm-player" ref={playerRef}>
                                        <div className="fm-player__header">
                                            <div className="fm-player__title">
                                                <span className="fm-player__label">Now playing:</span>{' '}
                                                {videos[current].title}
                                            </div>
                                            <button
                                                type="button"
                                                className="fm-player__close"
                                                onClick={handleClose}
                                                aria-label="Close video"
                                            >
                                                ✕
                                            </button>
                                        </div>
                                        <div className="fm-player__frame">{renderPlayer()}</div>
                                        {error && <div className="fm-player__error">{error}</div>}
                                    </div>
                                )}

                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Serial no.</th>
                                                <th>Guest Name</th>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {videos.map((video, index) => {
                                                const active = current === index;
                                                return (
                                                    <tr key={index} className={active ? 'fm-row--active' : ''}>
                                                        <td>{index + 1}</td>
                                                        <td>{video.title}</td>
                                                        <td>{video.date}</td>
                                                        <td>
                                                            {video.src ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-download"
                                                                    onClick={() => handleWatch(index)}
                                                                    aria-pressed={active}
                                                                    aria-label={`Play ${video.title}`}
                                                                >
                                                                    {active ? '● Playing' : '▶ Play'}
                                                                </button>
                                                            ) : (
                                                                <span className="fm-soon">Coming Soon</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* YouTube channel */}
                                <div className="fm-youtube">
                                    <FontAwesomeIcon icon={faYoutube} className="fm-youtube__icon" />
                                    <div className="fm-youtube__text">
                                        <h3 className="fm-youtube__title">Watch us on YouTube</h3>
                                        <p className="fm-youtube__desc">
                                            Catch interviews, talks and programmes from CCSU on our official YouTube channel.
                                        </p>
                                    </div>
                                    <a
                                        href={YOUTUBE_CHANNEL_URL}
                                        className="btn fm-youtube__btn"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Visit Channel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
